#import "./PolicyDetailFields.graphql"

mutation ReadPolicyDocumentAgain($documentId: ID!) {
  readPolicyDocumentAgain(input: { documentId: $documentId }) {
    policy {
      ...PolicyDetailFields
    }
  }
}
